import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Add event listener for checkbox changes
    this.addCheckboxListeners()
  }

  addCheckboxListeners() {
    const checkboxes = document.querySelectorAll('[id^="confirm-acceptance-"]')
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', this.handleCheckboxChange.bind(this))
    })
  }

  handleCheckboxChange(event) {
    const quoteId = event.target.dataset.quoteId
    const acceptButton = document.querySelector(`#accept-button-${quoteId}`)
    const disabledClasses = 'opacity-60 pointer-events-none select-none transition-opacity duration-200 dark:opacity-50 dark:bg-opacity-50 dark:hover:bg-opacity-50 dark:focus:ring-0 dark:focus:ring-offset-0'.split(' ')
    
    if (acceptButton) {
      if (event.target.checked) {
        acceptButton.removeAttribute('disabled')
        acceptButton.classList.remove(...disabledClasses)
      } else {
        acceptButton.setAttribute('disabled', '')
        acceptButton.classList.add(...disabledClasses)
      }
    }
  }

  showModal(event) {
    const quoteId = event.currentTarget.dataset.quoteId
    const modal = document.getElementById(`accept-modal-${quoteId}`)
    
    if (modal) {
      modal.classList.remove('hidden')
      const checkbox = document.querySelector(`input[data-quote-id="${quoteId}"]`)
      
      if (checkbox) {
        checkbox.checked = false
        checkbox.addEventListener('change', this.handleCheckboxChange.bind(this))
      }
    }
  }

  closeModal() {
    const modals = document.querySelectorAll('[id^="accept-modal-"]')
    modals.forEach(modal => {
      modal.classList.add('hidden')
    })
  }

  acceptQuote(event) {
    event.preventDefault()

    const quoteId = event.currentTarget.dataset.quoteId
    const checkbox = document.querySelector(`input[data-quote-id="${quoteId}"]`)
    
    if (!checkbox.checked) {
      alert('You must confirm the terms before accepting the quote.')
      return
    }
    
    const acceptButton = document.querySelector(`#accept-button-${quoteId}`)
    const spinnerButton = document.querySelector(`#accept-button-spinner-${quoteId}`)
    
    if (acceptButton && spinnerButton) {
      acceptButton.classList.add('!hidden')
      spinnerButton.classList.remove('!hidden')
    }
    
    const form = document.getElementById(`accept-quote-form-${quoteId}`)
    if (form) {
      form.submit()
    }
  }
}
